import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { isLoggedIn } from "utils";

// ********************************* Login Api's ******************************************

export const login = async (data) => {
  // console.log("decryptData",decryptData(data))
  // console.log("encryptData",encryptData(data))
  // console.log("res", { reqData: encryptData(data) })
  return decryptData(
    await axios.post(`/login`, { reqData: encryptData(data) })
  );
};

export const forgotPassword = async (data) => {
  return decryptData(
    await axios.post(`/forgot-password`, { reqData: encryptData(data) })
  );
};
